import { Layout } from '@/views/notifications';

export default {
    path: '/notifications',
    component: Layout,
    children: [
        { path: ':id', component: () => import('@/views/notifications/NotificationDetail.vue') },
    ]
};
